import { useApplicants } from '@/contexts/ApplicantContext';
import clsx from 'clsx';

export function ApplicantToggle() {
  const { applicants, current, setCurrent, loading } = useApplicants();
  if (loading || applicants.length === 0) {
    return <div className="h-7 w-32 animate-pulse rounded-md bg-gray-200" />;
  }
  if (applicants.length === 1) {
    const a = applicants[0];
    return (
      <span className="rounded-md border border-gray-200 bg-white px-2.5 py-1 text-xs text-gray-600">
        {a.display_name}
      </span>
    );
  }
  return (
    <div className="flex rounded-md border border-gray-200 bg-white p-0.5 text-xs">
      {applicants.map((a) => (
        <button
          key={a.applicant_id}
          onClick={() => setCurrent(a.applicant_id)}
          className={clsx(
            'rounded px-2.5 py-1 transition',
            current === a.applicant_id
              ? 'bg-primary-600 font-medium text-white'
              : 'text-gray-600 hover:bg-gray-100',
          )}
        >
          {a.display_name}
          {a.paused === 1 && <span className="ml-1 text-amber-300">⏸</span>}
        </button>
      ))}
    </div>
  );
}
